import React, { useEffect, useState } from 'react';
import { useCookies, withCookies } from 'react-cookie';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Header';

const ResetComponent = ({ api }) => {
  const navigate = useNavigate()

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const token = queryParams.get("token")

  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');


  const handleReset = async (e) => {
    e.preventDefault();

    if (!loading && token) {
      setLoading(true)
      try {
        const resp = await api().resetPassword({
          email: email,
          password: password,
          token: token
        })

        if (resp.status === 200) {
          navigate('/login')
        }

      } catch (error) {
        setError(error.response.data.message)
      }
      setLoading(false)
    }
  };

  return (
    <div className="bg-gradient-to-b from-blue-400 to-green-700 min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-sm w-full">
        <h2 className="text-2xl font-semibold mb-6 text-center">Reset password</h2>
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
        <form onSubmit={handleReset}>
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              id="email"
              className="w-full p-2 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-6">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
            <input
              type="password"
              id="password"
              className="w-full p-2 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            disabled={loading}
            type="submit"
            className={
              loading
                ? "w-full p-2 bg-gray-200 text-white rounded-md  focus:outline-none"
                : "w-full p-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none"
            }
          >
            Reset password
          </button>
        </form>
      </div>
    </div>
  );
};

const Reset = withCookies(({ api }) => (
  <div>
    <Header api={api} />
    <ResetComponent api={api} />
  </div>
))

export default Reset;